module.exports = __webpack_public_path__ + "media/src/images/logos/twitter-logo-0d36bc06fcc6b365ec3850deddcc7ca4.png";